import { css, SerializedStyles } from '@core-ui/react-stitch';

const getStyles = (): SerializedStyles => css`padding-left: 0.5rem;`;

export default getStyles;
